import { useFactoryApp } from './useFactoryApp';

export function useFeatureFlag(key: string): boolean {
  const { data } = useFactoryApp();
  return data?.settings?.features?.find((f) => f.key === key)?.enabled ?? false;
}
